__webpack_require__.p = "https://bmidxbfinlandplprod.netlify.app/";